import React from "react";
import XLSX from "xlsx";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ProportionsPage from "../proportions/ProportionsPage";
import HourValuesPage from "../hourValues/HourValuesPage";
import moment from "moment";
import Select from "react-select";
import FirebaseApi from "../../api/firebase";
import toastr from "toastr";
import DatePicker from "react-datepicker";
import SchedulesPage from "../schedules/SchedulesPage";
import BonusPage from "../bonus/BonusPage";

class ConfigPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      year: moment().year(),
      year_for_hour_values: moment().year(),
      rows: {
        A: this.generateProportionsTable(),
        B: this.generateProportionsTable(),
      },
      hour_values: {
        A: this.generateHourValuesTable(),
        B: this.generateHourValuesTable(),
        C: this.generateHourValuesTable(),
      },
      schedule_rows: {
        A: this.generateScheduleTable(),
      },
      bonus_rows: this.generateBonusTable(),
      loading: true,
      proportions_start_date: moment().format("DD-MM-YYYY"),
      proportions_end_date: moment().format("DD-MM-YYYY"),
      proportions_name: "",
      start_date_filled: false,
      end_date_filled: false,
      proportions_selected: false,
      proportions_options: [],
      schedule_type: {
        value: "",
        label: "",
      },
      schedule_name: "",
      schedule_start_date: moment().format("DD-MM-YYYY"),
      schedule_end_date: moment().format("DD-MM-YYYY"),
      schedule_start_hour: "",
      schedule_bonus_hour_price: 0,
      schedule_pie_bonus_hour_price: 0,
      schedule_movilization_bonus: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      schedule_selected: false,
      schedules_options: [],
      schedule_rows_count: 15,
    };
  }

  componentWillMount = () => {
    //this.retrieveYearProportions()
    this.retrieveYearHourValues();
    this.retrieveProportionsOptions();
  };

  // handleYearChange = (year) => {
  //   this.setState({
  //     year: year.value,
  //     loading: true
  //   }, () => {
  //     this.retrieveYearProportions()
  //   })
  // }

  handleProportionsChange = (proportions_name) => {
    this.setState(
      {
        proportions_name: proportions_name.value,
        proportions_selected: true,
        loading: true,
      },
      () => {
        this.retrieveProportions();
      }
    );
  };

  handleScheduleChange = (schedules_name) => {
    this.setState(
      {
        schedule_name: schedules_name.value,
        schedule_selected: true,
        loading: true,
      },
      () => {
        this.retrieveSchedule();
      }
    );
  };

  handleYearForHourValuesChange = (year) => {
    this.setState(
      {
        year_for_hour_values: year.value,
        loading: true,
      },
      () => {
        this.retrieveYearHourValues();
      }
    );
  };

  handleGenericChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const id = target.id;

    this.setState({
      [id]: value,
    });
  };

  handleMovilizationBonusChange = (event) => {
    const target = event.target;
    const value = target.value;
    const id = target.id;

    let mov_bonus = this.state.schedule_movilization_bonus;

    mov_bonus[id] = parseFloat(value);

    this.setState({
      schedule_movilization_bonus: mov_bonus,
    });
  };

  handleProportionsStartDateChange = (date) => {
    this.setState({
      proportions_start_date: date.format("DD-MM-YYYY"),
      start_date_filled: true,
    });
  };

  handleProportionsEndDateChange = (date) => {
    this.setState({
      proportions_end_date: date.format("DD-MM-YYYY"),
      end_date_filled: true,
    });
  };

  handleScheduleStartDateChange = (date) => {
    this.setState({
      schedule_start_date: date.format("DD-MM-YYYY"),
      start_date_filled: true,
    });
  };

  handleScheduleEndDateChange = (date) => {
    this.setState({
      schedule_end_date: date.format("DD-MM-YYYY"),
      end_date_filled: true,
    });
  };

  retrieveProportions = () => {
    FirebaseApi.GetValues("/proportions/" + this.state.proportions_name)
      .then((snap) => {
        let proportionsObj = snap.val();
        if (proportionsObj) {
          this.setState({
            rows: {
              A: proportionsObj["A"],
              B: proportionsObj["B"],
            },
            loading: false,
            row_count: proportionsObj["A"].length,
            proportions_end_date: proportionsObj["end_date"],
            proportions_start_date: proportionsObj["start_date"],
          });
        } else {
          let new_rows = {
            A: this.generateProportionsTable(),
            B: this.generateProportionsTable(),
          };
          this.setState({ rows: new_rows, loading: false, row_count: 45 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //CHECK
  retrieveSchedule = () => {
    FirebaseApi.GetValues(
      "/schedules/" +
        this.state.schedule_type.value +
        "/" +
        this.state.schedule_name
    )
      .then((snap) => {
        let scheduleObj = snap.val();
        if (scheduleObj) {
          //REVISAR
          this.setState({
            schedule_rows: {
              A: scheduleObj["schedule_format"],
            },
            bonus_rows: scheduleObj["bonus_values"]
              ? scheduleObj["bonus_values"]
              : this.generateBonusTable(),
            loading: false,
            schedule_rows_count: scheduleObj["schedule_format"].length,
            schedule_end_date: scheduleObj["end_date"],
            schedule_start_date: scheduleObj["start_date"],
            schedule_movilization_bonus: scheduleObj["movilization_bonus"],
            schedule_pie_bonus_hour_price: scheduleObj["bonus_hour_price_PIE"],
            schedule_bonus_hour_price: scheduleObj["bonus_hour_price"],
            schedule_start_hour: scheduleObj["begin_time"],
          });
        } else {
          let new_rows = {
            A: this.generateScheduleTable(),
            B: this.generateScheduleTable(),
          };
          this.setState({
            schedule_rows: new_rows,
            loading: false,
            schedule_row_count: 15,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  retrieveYearHourValues = () => {
    FirebaseApi.GetValues("/hour_values/" + this.state.year_for_hour_values)
      .then((snap) => {
        let hour_values_obj = snap.val();
        if (hour_values_obj) {
          this.setState({
            hour_values: {
              A: hour_values_obj["A"],
              B: hour_values_obj["B"],
              C: hour_values_obj["C"],
            },
            loading: false,
          });
        } else {
          let new_rows = {
            A: this.generateHourValuesTable(),
            B: this.generateHourValuesTable(),
            C: this.generateHourValuesTable(),
          };
          this.setState({ hour_values: new_rows, loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  generateProportionsTable = () => {
    let rows = [];
    for (let i = 0; i < 45; i++) {
      let row = {
        label: i,
        academic: 0,
        non_academic: 0,
        break: 0,
      };
      rows.push(row);
    }

    return rows;
  };

  generateBonusTable = () => {
    let rows = [];
    for (let i = 0; i < 45; i++) {
      let row = {
        label: i,
        titulo: 0,
        mencion: 0,
      };
      rows.push(row);
    }

    return rows;
  };

  generateHourValuesTable = () => {
    let rows = [];

    let current_year =
      this.state != null ? this.state.year_for_hour_values : moment().year();
    let row_count = current_year - 1992 + 1;

    for (let i = 0; i < row_count; i++) {
      let row = {
        label: 1992 + i,
        middle: 0,
        high: 0,
      };
      rows.push(row);
    }

    return rows;
  };

  generateScheduleTable = () => {
    let rows = [];

    for (let i = 0; i < 15; i++) {
      let row = {
        label: i,
        type: "no_type",
        minutes: 0,
      };
      rows.push(row);
    }

    return rows;
  };

  generateYearOptions = () => {
    //We add 2 so users can set next year's proportions
    let last_possible_year = moment().year() + 2;
    let array_length = last_possible_year - 1992;

    let years = Array.from(new Array(array_length), (x, i) => 1992 + i).map(
      (year) => {
        return { value: year, label: year };
      }
    );

    return years;
  };

  retrieveProportionsOptions = () => {
    let options = [];
    FirebaseApi.GetValues("/proportions").then((snap) => {
      let vals = snap.val();
      if (vals) {
        options = Object.keys(vals).map((item) => {
          return { value: item, label: item };
        });
      }
      this.setState({
        proportions_options: options,
      });
    });
  };

  retrieveSchedulesOptions = () => {
    let options = [];
    FirebaseApi.GetValues("/schedules/" + this.state.schedule_type.value).then(
      (snap) => {
        let vals = snap.val();
        if (vals) {
          options = Object.keys(vals).map((item) => {
            return { value: item, label: item };
          });
        }
        this.setState({
          schedules_options: options,
        });
      }
    );
  };

  updateProportions = (type) => {
    //New proportions
    if (
      this.state.proportions_name != "" &&
      this.state.start_date_filled &&
      this.state.end_date_filled &&
      !this.state.proportions_selected
    ) {
      //We check if the key exists
      FirebaseApi.GetValueByKeyOnce(
        "/proportions/",
        this.state.proportions_name
      ).then((snap) => {
        let proportions = snap.val();
        if (proportions) {
          alert("Proporciones con ese nombre ya existen");
        } else {
          //TODO: CHECK IF PROPORTIONS DATE RANGE IS COVERED BY ANY EXISTING PROPORTIONS
          this.checkIfDateRangeIsAvailable(
            this.state.proportions_start_date,
            this.state.proportions_end_date,
            "/proportions",
            this.state.proportions_name
          ).then((res) => {
            console.log(res);
            if (res.isAvailable) {
              let proportions = this.state.rows;
              proportions["start_date"] = this.state.proportions_start_date;
              proportions["end_date"] = this.state.proportions_end_date;
              FirebaseApi.databaseSet(
                "/proportions/" + this.state.proportions_name,
                proportions
              ).then((val) => {
                toastr.success("Proporciones Creadas");
                this.props.history.push("/");
              });
            } else {
              alert(
                "El item de nombre '" +
                  res.conflicting_name +
                  "' contiene o esta contenido en el rango del nuevo item"
              );
            }
          });
        }
      });
    }
    //Modifying and updating existing proportion
    else if (
      this.state.proportions_name != "" &&
      this.state.proportions_selected
    ) {
      //TODO: CHECK IF PROPORTIONS DATE RANGE IS COVERED BY ANY EXISTING PROPORTIONS
      this.checkIfDateRangeIsAvailable(
        this.state.proportions_start_date,
        this.state.proportions_end_date,
        "/proportions",
        this.state.proportions_name
      ).then((res) => {
        console.log(res);
        if (res.isAvailable) {
          let proportions = this.state.rows;
          proportions["start_date"] = this.state.proportions_start_date;
          proportions["end_date"] = this.state.proportions_end_date;
          FirebaseApi.databaseSet(
            "/proportions/" + this.state.proportions_name,
            proportions
          ).then((val) => {
            toastr.success("Proporciones Actualizadas");
            this.props.history.push("/");
          });
        } else {
          alert(
            "El item de nombre '" +
              res.conflicting_name +
              "' contiene o esta contenido en el rango del nuevo item, actualizando"
          );
        }
      });
    } else {
      alert(
        "Es necesario completar y cambiar nombre y ambas fecha para crear nueva proporción"
      );
    }
  };

  updateSchedule = (type) => {
    //New Schedule
    if (
      this.state.schedule_name != "" &&
      this.state.start_date_filled &&
      this.state.end_date_filled &&
      !this.state.schedule_selected
    ) {
      //We check if the key exists
      FirebaseApi.GetValueByKeyOnce(
        "/schedules/" + this.state.schedule_type.value,
        this.state.schedule_name
      ).then((snap) => {
        let schedule = snap.val();
        if (schedule) {
          alert("Horario con ese nombre ya existe");
        } else {
          this.checkIfDateRangeIsAvailable(
            this.state.schedule_start_date,
            this.state.schedule_end_date,
            "/schedules/" + this.state.schedule_type.value,
            this.state.schedule_name
          ).then((res) => {
            if (res.isAvailable) {
              let schedule = {};
              schedule["schedule_format"] = this.state.schedule_rows.A;
              schedule["start_date"] = this.state.schedule_start_date;
              schedule["end_date"] = this.state.schedule_end_date;
              schedule["begin_time"] = this.state.schedule_start_hour;
              schedule["bonus_hour_price_PIE"] =
                this.state.schedule_pie_bonus_hour_price;
              schedule["bonus_hour_price"] =
                this.state.schedule_bonus_hour_price;
              schedule["movilization_bonus"] =
                this.state.schedule_movilization_bonus;
              schedule["bonus_values"] = this.state.bonus_rows;
              FirebaseApi.databaseSet(
                "/schedules/" +
                  this.state.schedule_type.value +
                  "/" +
                  this.state.schedule_name,
                schedule
              ).then((val) => {
                toastr.success("Horario Creado");
                this.props.history.push("/");
              });
            } else {
              alert(
                "El item de nombre '" +
                  res.conflicting_name +
                  "' contiene o esta contenido en el rango del nuevo item"
              );
            }
          });
        }
      });
    }
    //Modifying and updating existing schedule
    else if (this.state.schedule_name != "" && this.state.schedule_selected) {
      this.checkIfDateRangeIsAvailable(
        this.state.schedule_start_date,
        this.state.schedule_end_date,
        "/schedules/" + this.state.schedule_type.value,
        this.state.schedule_name
      ).then((res) => {
        if (res.isAvailable) {
          let schedule = {};
          schedule["schedule_format"] = this.state.schedule_rows.A;
          schedule["start_date"] = this.state.schedule_start_date;
          schedule["end_date"] = this.state.schedule_end_date;
          schedule["begin_time"] = this.state.schedule_start_hour;
          schedule["bonus_hour_price_PIE"] =
            this.state.schedule_pie_bonus_hour_price;
          schedule["bonus_hour_price"] = this.state.schedule_bonus_hour_price;
          schedule["movilization_bonus"] =
            this.state.schedule_movilization_bonus;
          schedule["bonus_values"] = this.state.bonus_rows;
          FirebaseApi.databaseSet(
            "/schedules/" +
              this.state.schedule_type.value +
              "/" +
              this.state.schedule_name,
            schedule
          ).then((val) => {
            toastr.success("Horario Actualizado");
            this.props.history.push("/");
          });
        } else {
          alert(
            "El item de nombre '" +
              res.conflicting_name +
              "' contiene o esta contenido en el rango del nuevo item, actualizando"
          );
        }
      });
    } else {
      alert(
        "Es necesario completar y cambiar nombre y ambas fecha para crear un nuevo horario"
      );
    }
  };
  deleteProportions = () => {
    FirebaseApi.RemoveChildByKey(
      "/proportions",
      this.state.proportions_name
    ).then((error) => {
      //this.setState({ show: false})
      this.prepareNewProportions();
      this.retrieveProportionsOptions();
    });
  };

  deleteSchedule = () => {
    FirebaseApi.RemoveChildByKey(
      "/schedules/" + this.state.schedule_type.value + "/",
      this.state.schedule_name
    ).then((error) => {
      //this.setState({ show: false})
      this.prepareNewSchedule();
      this.retrieveSchedulesOptions();
    });
  };

  checkIfDateRangeIsAvailable = (
    start_date,
    end_date,
    db_path,
    checking_name
  ) => {
    //We download all date ranges from db
    return FirebaseApi.GetValues(db_path).then((snap) => {
      let objs = snap.val();
      let isAvailable = true;
      let conflicting_name = "";
      if (objs) {
        let objs_keys = Object.keys(objs);
        objs_keys.forEach((key) => {
          let current_proportions_set = objs[key];
          let start_date_is_available = this.checkDateRangeIntersection(
            current_proportions_set["start_date"],
            current_proportions_set["end_date"],
            start_date
          );
          let end_date_is_available = this.checkDateRangeIntersection(
            current_proportions_set["start_date"],
            current_proportions_set["end_date"],
            end_date
          );

          //Check if new range contains any pre existing range
          let new_range_contains_current_start_date =
            this.checkDateRangeIntersection(
              start_date,
              end_date,
              current_proportions_set["start_date"]
            );
          let new_range_contains_current_end_date =
            this.checkDateRangeIntersection(
              start_date,
              end_date,
              current_proportions_set["end_date"]
            );

          let current_set_conflicts = false;
          current_set_conflicts =
            start_date_is_available ||
            end_date_is_available ||
            new_range_contains_current_start_date ||
            new_range_contains_current_end_date;

          if (current_set_conflicts && checking_name != key) {
            isAvailable = false;
            conflicting_name = key;
          }
        });
      }

      return {
        isAvailable: isAvailable,
        conflicting_name: conflicting_name,
      };
    });
  };

  checkDateRangeIntersection = (start_date, end_date, checking_date) => {
    let start = moment(start_date, "DD-MM-YYYY");
    let end = moment(end_date, "DD-MM-YYYY");
    let checking = moment(checking_date, "DD-MM-YYYY");

    return checking.isBetween(start, end, null, []);
  };

  updateHourValues = (type) => {
    let hour_values = this.state.hour_values;
    FirebaseApi.databaseSet(
      "/hour_values/" + this.state.year_for_hour_values,
      hour_values
    ).then((val) => {
      toastr.success("Valores Hora Actualizados");
      this.props.history.push("/");
    });
  };

  updateProportionsRowsInfo = (cellInfo, value, type) => {
    const data = this.state.rows;
    data[type][cellInfo.index][cellInfo.column.id] = value;
    this.setState({ rows: data });
  };

  updateScheduleRowsInfo = (cellInfo, value, type) => {
    const data = this.state.schedule_rows;
    data[type][cellInfo.index][cellInfo.column.id] = value;
    this.setState({ schedule_rows: data });
  };

  updateBonusRowsInfo = (cellInfo, value) => {
    const data = this.state.bonus_rows;
    data[cellInfo.index][cellInfo.column.id] = value;
    this.setState({ bonus_rows: data });
  };

  updateHourValuesRowsInfo = (cellInfo, value, type) => {
    const data = this.state.hour_values;
    data[type][cellInfo.index][cellInfo.column.id] = value;
    this.setState({ hour_values: data });
  };

  checkRowCountInvalidNumberInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (value == "") {
      this.setState({ row_count: 0 }, this.modifyRowCount(0));
    } else {
      this.modifyRowCount(parseFloat(value));
    }
  };

  checkScheduleRowCountInvalidNumberInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (value == "") {
      this.setState({ schedule_rows_count: 0 }, this.modifyScheduleRowCount(0));
    } else {
      this.modifyScheduleRowCount(parseFloat(value));
    }
  };
  checkMovilizationInvalidNumberInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let id = event.target.id;
    let mov_values = this.state.schedule_movilization_bonus;
    if (value == "") {
      mov_values[id] = 0;
      this.setState({ schedule_movilization_bonus: mov_values });
    } else {
    }
  };

  handleRowCountChange = (count) => {
    let fcount = parseFloat(count.target.value);
    this.setState({ row_count: fcount });
  };

  handleScheduleRowCountChange = (count) => {
    let fcount = parseFloat(count.target.value);
    this.setState({ schedule_rows_count: fcount });
  };

  modifyRowCount = (new_row_count) => {
    let keys = Object.keys(this.state.rows);
    let current_count = keys.length > 0 ? this.state.rows[keys[0]].length : 0;
    let new_rows = {};

    if (current_count == new_row_count) {
      return;
    }

    //We have to delete rows
    if (current_count > new_row_count) {
      let rows_to_delete = current_count - new_row_count;
      keys.forEach((key) => {
        let current_rows = this.state.rows[key];
        let i;
        for (i = current_rows.length - 1; i >= new_row_count; i--) {
          current_rows.splice(-1, 1);
        }
        new_rows[key] = current_rows;
      });
    }

    //We have to add new rows
    else if (current_count < new_row_count) {
      let rows_to_add = new_row_count - current_count;
      let sample_row = {
        label: 0,
        academic: 0,
        non_academic: 0,
        break: 0,
      };

      keys.forEach((key) => {
        let current_rows = this.state.rows[key];
        let i;
        for (i = 0; i < new_row_count - current_count; i++) {
          let new_sample_row = Object.assign({}, sample_row);
          new_sample_row["label"] = i + current_count;
          current_rows.push(new_sample_row);
        }
        new_rows[key] = current_rows;
      });
    }
    this.setState({ rows: new_rows });
  };

  modifyScheduleRowCount = (new_row_count) => {
    let keys = Object.keys(this.state.schedule_rows);
    let current_count =
      keys.length > 0 ? this.state.schedule_rows[keys[0]].length : 0;
    let new_rows = {};

    if (current_count == new_row_count) {
      return;
    }

    //We have to delete rows
    if (current_count > new_row_count) {
      let rows_to_delete = current_count - new_row_count;
      keys.forEach((key) => {
        let current_rows = this.state.schedule_rows[key];
        let i;
        for (i = current_rows.length - 1; i >= new_row_count; i--) {
          current_rows.splice(-1, 1);
        }
        new_rows[key] = current_rows;
      });
    }

    //We have to add new rows
    else if (current_count < new_row_count) {
      let rows_to_add = new_row_count - current_count;
      let sample_row = {
        label: 0,
        type: 0,
        minutes: 0,
      };

      keys.forEach((key) => {
        let current_rows = this.state.schedule_rows[key];
        let i;
        for (i = current_count; i < new_row_count; i++) {
          let new_sample_row = Object.assign({}, sample_row);
          new_sample_row["label"] = i;
          current_rows.push(new_sample_row);
        }
        new_rows[key] = current_rows;
      });
    }
    this.setState({ schedule_rows: new_rows });
  };

  prepareNewProportions = () => {
    this.setState({
      year: moment().year(),
      year_for_hour_values: moment().year(),
      rows: {
        A: this.generateProportionsTable(),
        B: this.generateProportionsTable(),
      },
      hour_values: {
        A: this.generateHourValuesTable(),
        B: this.generateHourValuesTable(),
        C: this.generateHourValuesTable(),
      },
      proportions_start_date: moment().format("DD-MM-YYYY"),
      proportions_end_date: moment().format("DD-MM-YYYY"),
      proportions_name: "",
      start_date_filled: false,
      end_date_filled: false,
      proportions_selected: false,
    });
  };

  //CHECK !!!!
  prepareNewSchedule = () => {
    this.setState({
      schedule_rows: {
        A: this.generateScheduleTable(),
        B: this.generateScheduleTable(),
      },
      hour_values: {
        A: this.generateHourValuesTable(),
        B: this.generateHourValuesTable(),
        C: this.generateHourValuesTable(),
      },
      bonus_rows: this.generateBonusTable(),
      schedule_start_date: moment().format("DD-MM-YYYY"),
      schedule_end_date: moment().format("DD-MM-YYYY"),
      schedule_name: "",
      start_date_filled: false,
      end_date_filled: false,
      schedule_selected: false,
      schedule_rows_count: 15,
    });
  };

  handleScheduleTypeChange = (selectedOption) => {
    this.setState({ schedule_type: selectedOption }, () => {
      this.retrieveSchedulesOptions();
    });
  };

  render() {
    return (
      <div className="jumbotron">
        <h1>Configuración</h1>
        <Tabs>
          <TabList>
            <Tab>Valores Hora</Tab>
            <Tab>Proporciones Ministerio</Tab>
            <Tab>Horarios</Tab>
          </TabList>

          <TabPanel>
            <h4>Elegir año para cargar valores hora</h4>
            <div className="form-group w-25">
              <div className="flex">
                <div className="full-width">
                  <Select
                    name="year"
                    id="year"
                    value={this.state.year_for_hour_values}
                    onChange={this.handleYearForHourValuesChange}
                    options={this.generateYearOptions()}
                    clearable={false}
                    placeholder="Año"
                  />
                </div>
                <div
                  className="title-spinner"
                  style={
                    this.state.loading
                      ? { display: "flex" }
                      : { display: "none" }
                  }
                >
                  <i
                    className="fas fa-circle-notch fa-spin fa-2x"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
            <Tabs>
              <TabList>
                <Tab>Tipo A</Tab>
                <Tab>Tipo B</Tab>
                <Tab>Tipo C</Tab>
              </TabList>
              <TabPanel>
                <HourValuesPage
                  history={this.props.history}
                  type="A"
                  rows={this.state.hour_values.A}
                  updateMethod={this.updateHourValues}
                  updateRowsInfo={this.updateHourValuesRowsInfo}
                />
              </TabPanel>
              <TabPanel>
                <HourValuesPage
                  history={this.props.history}
                  type="B"
                  rows={this.state.hour_values.B}
                  updateMethod={this.updateHourValues}
                  updateRowsInfo={this.updateHourValuesRowsInfo}
                />
              </TabPanel>
              <TabPanel>
                <HourValuesPage
                  history={this.props.history}
                  type="C"
                  rows={this.state.hour_values.C}
                  updateMethod={this.updateHourValues}
                  updateRowsInfo={this.updateHourValuesRowsInfo}
                />
              </TabPanel>
            </Tabs>
          </TabPanel>
          <TabPanel>
            <h4>Elegir proporciones a cargar para actualizar</h4>
            <div className="form-group w-25">
              <div className="flex">
                <div className="full-width">
                  <Select
                    name="year"
                    id="year"
                    value={this.state.proportions_name}
                    onChange={this.handleProportionsChange}
                    options={this.state.proportions_options}
                    clearable={false}
                    placeholder="Nombre de proporciones"
                  />
                </div>
                <div
                  className="title-spinner"
                  style={
                    this.state.loading
                      ? { display: "flex" }
                      : { display: "none" }
                  }
                >
                  <i
                    className="fas fa-circle-notch fa-spin fa-2x"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
            <h3>
              {this.state.proportions_selected
                ? "Actualizando proporciones " + this.state.proportions_name
                : "Creando nuevas proporciones"}
            </h3>
            <div
              className="update-proportions-button"
              style={
                this.state.proportions_selected
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <button
                className="btn btn-success"
                onClick={() => this.prepareNewProportions()}
              >
                Cambiar a crear nuevas proporciones
              </button>
            </div>
            <div className="form-group w-25">
              <label htmlFor="row-count">Nombre para proporciones</label>
              <input
                value={this.state.proportions_name}
                type="text"
                id="proportions_name"
                className="form-control"
                name="proportions_name"
                onChange={this.handleGenericChange}
              ></input>
            </div>
            <div className="form-group">
              <label>Fecha de inicio</label>
              <DatePicker
                selected={moment(
                  this.state.proportions_start_date,
                  "DD-MM-YYYY"
                )}
                onChange={this.handleProportionsStartDateChange}
                id="proportions_start_date"
                scrollableYearDropdown
                showYearDropdown
                dateFormatCalendar="MMMM"
                minDate={moment("1-1-1992", "DD-MM-YYYY")}
                yearDropdownItemNumber={30}
                dateFormat="DD/MM/YYYY"
              />
            </div>
            <div className="form-group">
              <label>Fecha de término</label>
              <DatePicker
                selected={moment(this.state.proportions_end_date, "DD-MM-YYYY")}
                onChange={this.handleProportionsEndDateChange}
                id="proportions_end_date"
                scrollableYearDropdown
                showYearDropdown
                dateFormatCalendar="MMMM"
                minDate={moment("1-1-1992", "DD-MM-YYYY")}
                yearDropdownItemNumber={30}
                dateFormat="DD/MM/YYYY"
              />
            </div>
            <div className="form-group w-25">
              <label htmlFor="row-count">Cantidad de filas</label>
              <input
                value={this.state.row_count}
                type="number"
                id="row_count"
                className="form-control"
                name="row_count"
                onBlur={this.checkRowCountInvalidNumberInput}
                onChange={this.handleRowCountChange}
              ></input>
            </div>
            <Tabs>
              <TabList>
                <Tab>Tipo A</Tab>
                <Tab>Tipo B</Tab>
              </TabList>
              <TabPanel>
                <ProportionsPage
                  history={this.props.history}
                  isNew={!this.state.proportions_selected}
                  deleteMethod={this.deleteProportions}
                  type="A"
                  rows={this.state.rows.A}
                  updateMethod={this.updateProportions}
                  updateRowsInfo={this.updateProportionsRowsInfo}
                />
              </TabPanel>
              <TabPanel>
                <ProportionsPage
                  history={this.props.history}
                  isNew={!this.state.proportions_selected}
                  deleteMethod={this.deleteProportions}
                  type="B"
                  rows={this.state.rows.B}
                  updateMethod={this.updateProportions}
                  updateRowsInfo={this.updateProportionsRowsInfo}
                />
              </TabPanel>
            </Tabs>
          </TabPanel>
          <TabPanel>
            <h1>Horarios</h1>
            <h4>Elegir Tipo y nombre de horario para cargar</h4>
            <div className="form-group w-25">
              <label htmlFor="schedule-type">Tipo de horario</label>
              <Select
                id="schedule-type"
                name="schedule_type"
                value={this.state.schedule_type.value}
                onChange={this.handleScheduleTypeChange}
                options={[
                  { value: "san-jose", label: "San José" },
                  { value: "san-joaquin", label: "San Joaquín" },
                  {
                    value: "san-joaquin-preescolar",
                    label: "San Joaquín Preescolar",
                  },
                  { value: "san-juan", label: "San Juan" },
                  { value: "san-juan-basica", label: "San Juan Básica" },
                  {
                    value: "san-juan-preescolar",
                    label: "San Juan Preescolar",
                  },
                  { value: "san-juan-media", label: "San Juan Media" },
                  {
                    value: "san-jose-preescolar",
                    label: "San José Preescolar",
                  },
                  { value: "san-jose-basica", label: "San José Básica" },
                  { value: "san-jose-media", label: "San José Media" },
                  {
                    value: "santa-julia-basica",
                    label: "Santa Julia Básica",
                  },
                  { value: "santa-julia-media", label: "Santa Julia Media" },
                  {
                    value: "santa-julia-preescolar",
                    label: "Santa Julia Preescolar",
                  },
                ]}
                placeholder="Seleccionar tipo de Horario"
              />
            </div>
            <div
              style={
                this.state.schedule_type.value != ""
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <div className="form-group w-25">
                <div className="flex">
                  <div className="full-width">
                    <label htmlFor="schedule-type">Nombre de horario</label>
                    <Select
                      name="year"
                      id="year"
                      value={this.state.schedule_name}
                      onChange={this.handleScheduleChange}
                      options={this.state.schedules_options}
                      clearable={false}
                      placeholder="Nombre de horarios"
                    />
                  </div>
                  <div
                    className="title-spinner"
                    style={
                      this.state.loading
                        ? { display: "flex" }
                        : { display: "none" }
                    }
                  >
                    <i
                      className="fas fa-circle-notch fa-spin fa-2x"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={
                this.state.schedule_type.value == ""
                  ? { display: "none" }
                  : { display: "block" }
              }
            >
              <h3>
                {this.state.schedule_selected
                  ? "Actualizando Horario " + this.state.schedule_name
                  : "Creando nuevo horario"}
              </h3>
              <div
                className="update-proportions-button"
                style={
                  this.state.schedule_selected
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <button
                  className="btn btn-success"
                  onClick={() => this.prepareNewSchedule()}
                >
                  Cambiar a crear nuevo horario
                </button>
              </div>
              <div className="form-group w-25">
                <label htmlFor="row-count">Nombre para horario</label>
                <input
                  value={this.state.schedule_name}
                  type="text"
                  id="schedule_name"
                  className="form-control"
                  name="schedule_name"
                  onChange={this.handleGenericChange}
                ></input>
              </div>
              <div className="form-group">
                <label>Fecha de inicio</label>
                <DatePicker
                  selected={moment(
                    this.state.schedule_start_date,
                    "DD-MM-YYYY"
                  )}
                  onChange={this.handleScheduleStartDateChange}
                  id="schedule_start_date"
                  scrollableYearDropdown
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  minDate={moment("1-1-1992", "DD-MM-YYYY")}
                  yearDropdownItemNumber={30}
                  dateFormat="DD/MM/YYYY"
                />
              </div>
              <div className="form-group">
                <label>Fecha de término</label>
                <DatePicker
                  selected={moment(this.state.schedule_end_date, "DD-MM-YYYY")}
                  onChange={this.handleScheduleEndDateChange}
                  id="schedule_end_date"
                  scrollableYearDropdown
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  minDate={moment("1-1-1992", "DD-MM-YYYY")}
                  yearDropdownItemNumber={30}
                  dateFormat="DD/MM/YYYY"
                />
              </div>
              <div className="form-group w-25">
                <label htmlFor="row-count">
                  Hora de inicio para el horario
                </label>
                <input
                  value={this.state.schedule_start_hour}
                  type="text"
                  id="schedule_start_hour"
                  className="form-control"
                  name="schedule_start_hour"
                  onChange={this.handleGenericChange}
                  placeholder="Formato hh:mm:ss"
                ></input>
              </div>
              <div className="form-group w-25">
                <label htmlFor="row-count">Valor hora para bonos</label>
                <input
                  value={this.state.schedule_bonus_hour_price}
                  type="number"
                  id="schedule_bonus_hour_price"
                  className="form-control"
                  name="schedule_bonus_hour_price"
                  onChange={this.handleGenericChange}
                  placeholder=""
                ></input>
              </div>
              <div className="form-group w-25">
                <label htmlFor="row-count">Valor hora para bonos PIE</label>
                <input
                  value={this.state.schedule_pie_bonus_hour_price}
                  type="number"
                  id="schedule_pie_bonus_hour_price"
                  className="form-control"
                  name="schedule_pie_bonus_hour_price"
                  onChange={this.handleGenericChange}
                  placeholder=""
                ></input>
              </div>
              <label htmlFor="row-count">Valor diario para movilización</label>
              <div className="movilization-container">
                <div className="form-group w-15">
                  <label htmlFor="row-count">0 días</label>
                  <input
                    value={this.state.schedule_movilization_bonus[0]}
                    type="number"
                    id="0"
                    className="form-control"
                    name="0"
                    onChange={this.handleMovilizationBonusChange}
                    onBlur={this.checkMovilizationInvalidNumberInput}
                    placeholder=""
                  ></input>
                </div>
                <div className="form-group w-15">
                  <label htmlFor="row-count">1 día</label>
                  <input
                    value={this.state.schedule_movilization_bonus[1]}
                    type="number"
                    id="1"
                    className="form-control"
                    name="1"
                    onChange={this.handleMovilizationBonusChange}
                    onBlur={this.checkMovilizationInvalidNumberInput}
                    placeholder=""
                  ></input>
                </div>
                <div className="form-group w-15">
                  <label htmlFor="row-count">2 días</label>
                  <input
                    value={this.state.schedule_movilization_bonus[2]}
                    type="number"
                    id="2"
                    className="form-control"
                    name="2"
                    onChange={this.handleMovilizationBonusChange}
                    onBlur={this.checkMovilizationInvalidNumberInput}
                    placeholder=""
                  ></input>
                </div>
                <div className="form-group w-15">
                  <label htmlFor="row-count">3 días</label>
                  <input
                    value={this.state.schedule_movilization_bonus[3]}
                    type="number"
                    id="3"
                    className="form-control"
                    name="3"
                    onChange={this.handleMovilizationBonusChange}
                    onBlur={this.checkMovilizationInvalidNumberInput}
                    placeholder=""
                  ></input>
                </div>
                <div className="form-group w-15">
                  <label htmlFor="row-count">4 días</label>
                  <input
                    value={this.state.schedule_movilization_bonus[4]}
                    type="number"
                    id="4"
                    className="form-control"
                    name="4"
                    onChange={this.handleMovilizationBonusChange}
                    onBlur={this.checkMovilizationInvalidNumberInput}
                    placeholder=""
                  ></input>
                </div>
                <div className="form-group w-15">
                  <label htmlFor="row-count">5 días</label>
                  <input
                    value={this.state.schedule_movilization_bonus[5]}
                    type="number"
                    id="5"
                    className="form-control"
                    name="5"
                    onChange={this.handleMovilizationBonusChange}
                    onBlur={this.checkMovilizationInvalidNumberInput}
                    placeholder=""
                  ></input>
                </div>
              </div>
              <BonusPage
                history={this.props.history}
                rows={this.state.bonus_rows}
                updateRowsInfo={this.updateBonusRowsInfo}
              />
              <div className="form-group w-25">
                <label htmlFor="row-count">Cantidad de filas</label>
                <input
                  value={this.state.schedule_rows_count}
                  type="number"
                  id="row_count"
                  className="form-control"
                  name="row_count"
                  onBlur={this.checkScheduleRowCountInvalidNumberInput}
                  onChange={this.handleScheduleRowCountChange}
                ></input>
              </div>
              <SchedulesPage
                history={this.props.history}
                isNew={!this.state.schedule_selected}
                deleteMethod={this.deleteSchedule}
                type="A"
                rows={this.state.schedule_rows.A}
                updateMethod={this.updateSchedule}
                updateRowsInfo={this.updateScheduleRowsInfo}
              />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

export default ConfigPage;



// WEBPACK FOOTER //
// ./src/components/config/ConfigPage.js